function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m135.992188 160.496094h144v56c0 4.417968 3.582031 8 8 8h40v82.457031l-58.808594 22.046875c-3.125 1.171875-5.195313 4.160156-5.191406 7.496094v40c0 4.417968 3.582031 8 8 8h144c4.417968 0 8-3.582032 8-8v-216.253906c30.230468-2.511719 54.035156-26.839844 55.886718-57.121094 1.851563-30.28125-18.808594-57.328125-48.511718-63.503906l-230.039063-39.007813c-.207031-.03125-1.089844-.113281-1.335937-.113281h-64c-4.417969 0-8 3.582031-8 8v144c0 4.417968 3.582031 8 8 8zm160 48v-48h32v48zm112 160h-128v-26.457032l58.808593-22.046874c3.125-1.171876 5.191407-4.160157 5.191407-7.496094v-152h64zm56-269.085938c-.027344 24.890625-20.199219 45.058594-45.089844 45.085938h-210.910156v-126.527344l220.359374 37.359375c20.738282 4.535156 35.546876 22.855469 35.640626 44.082031zm-320-82.914062h48v128h-48zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m382.65625 80.039062 39.3125 6.648438c5.851562 1.457031 9.972656 6.691406 10.023438 12.722656.003906 4-1.832032 7.78125-4.976563 10.253906-3.460937 2.75-4.039063 7.78125-1.292969 11.246094 2.75 3.460938 7.78125 4.039063 11.246094 1.289063 6.976562-5.5 11.039062-13.902344 11.023438-22.789063-.160157-13.589844-9.582032-25.308594-22.816407-28.386718l-39.847656-6.757813c-4.355469-.738281-8.488281 2.195313-9.226563 6.550781-.734374 4.355469 2.195313 8.488282 6.554688 9.222656zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m350.65625 74.617188 8 1.351562c.441406.078125.890625.113281 1.34375.113281 4.15625-.003906 7.617188-3.191406 7.964844-7.335937.347656-4.140625-2.539063-7.859375-6.636719-8.554688l-8-1.351562c-4.355469-.738282-8.488281 2.195312-9.226563 6.554687-.734374 4.355469 2.195313 8.484375 6.554688 9.222657zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m103.992188 72.496094h-32c-4.417969 0-8 3.582031-8 8 0 4.417968 3.582031 8 8 8h32c4.417968 0 8-3.582032 8-8 0-4.417969-3.582032-8-8-8zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.046875 32.257812 96 24c.636719.160157 1.289063.242188 1.945313.238282 4.035156-.003906 7.4375-3.015625 7.929687-7.023438.492187-4.007812-2.078125-7.753906-5.996094-8.734375l-96-24c-4.269531-1.039062-8.578125 1.5625-9.648437 5.828125-1.066406 4.265625 1.503906 8.59375 5.761718 9.691406zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m7.992188 144.496094c.65625.003906 1.3125-.078125 1.949218-.238282l96-24c4.257813-1.097656 6.832032-5.425781 5.761719-9.691406-1.066406-4.265625-5.375-6.867187-9.648437-5.828125l-96 24c-3.917969.980469-6.488282 4.726563-5.9960942 8.734375.4921872 4.007813 3.8945312 7.019532 7.9335942 7.023438zm0 0"
});

var SvgScanner = function SvgScanner(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "479pt",
    viewBox: "0 -47 479.99386 479",
    width: "479pt",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scanner.4bd61d16.svg";
export { ForwardRef as ReactComponent };